export const EXCERPT_MAX_CHARS = 200
